import { Link } from "react-router-dom";
import { useState } from "react";
import { CommandPalette, SearchTrigger } from "@/components/CommandPalette";
import { useTheme } from "next-themes";
import { Bell, Menu, Moon, Sun, PanelLeftClose, PanelLeftOpen } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useBadges } from "@/context/BadgeContext";
import { ROLES } from "@/lib/constants";
import { Badge } from "@/components/ui/badge";

export const Header = ({ onMenu, collapsed, onCollapse }) => {
  const [cmd, setCmd] = useState(false);
  const { theme, setTheme } = useTheme();
  const { user } = useAuth();
  const { unread } = useBadges();
  return (
    <header className="sticky top-0 z-30 h-16 flex items-center justify-between px-4 md:px-6 border-b border-border bg-background/80 backdrop-blur-md">
      <div className="flex items-center gap-2">
        <button data-testid="mobile-menu-button" onClick={onMenu} className="md:hidden p-2 rounded-lg hover:bg-muted"><Menu className="h-5 w-5" /></button>
        <button data-testid="sidebar-collapse-button" onClick={onCollapse} className="hidden md:inline-flex p-2 rounded-lg hover:bg-muted text-muted-foreground">
          {collapsed ? <PanelLeftOpen className="h-5 w-5" /> : <PanelLeftClose className="h-5 w-5" />}
        </button>
        <Badge variant="outline" data-testid="header-role-badge" className="ml-1 font-mono text-[10px] tracking-wider uppercase">{ROLES[user.role]}</Badge>
        <SearchTrigger onClick={() => setCmd(true)} />
        <CommandPalette open={cmd} setOpen={setCmd} />
      </div>
      <div className="flex items-center gap-1">
        <Link to="/notifications" data-testid="header-notifications-link" className="relative p-2 rounded-lg hover:bg-muted">
          <Bell className="h-5 w-5" />
          {unread > 0 && <span data-testid="header-unread-count" className="absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] rounded-full bg-primary text-primary-foreground text-[10px] font-bold grid place-items-center px-1">{unread}</span>}
        </Link>
        <button data-testid="theme-toggle-button" onClick={() => setTheme(theme === "dark" ? "light" : "dark")} className="p-2 rounded-lg hover:bg-muted">
          {theme === "dark" ? <Sun className="h-5 w-5" /> : <Moon className="h-5 w-5" />}
        </button>
      </div>
    </header>
  );
};
